import { useRef } from "react";
import scrollDownIcon from "../../../assets/general/scroll-down-icon.svg";
import { Header } from "../../layout/Header/Header";
import { Footer } from "../../layout/Footer/Footer";
import { MobileMenu } from "../../layout/MobileMenu/MobileMenu";
import { ContactForm } from "../../contact/ContactForm/ContactForm";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

interface HeroProps {
  showContact: boolean;
  isMobileMenuOpen: boolean;
  onContactUs: () => void;
  onLegal: () => void;
  onMobileMenuToggle: () => void;
}

export function Hero({
  showContact,
  isMobileMenuOpen,
  onContactUs,
  onLegal,
  onMobileMenuToggle,
}: HeroProps) {
  const sectionRef = useRef<HTMLElement>(null);

  useScrollReveal(sectionRef, { targets: ".main-title", delay: 0.2, scrollTrigger: false });
  useScrollReveal(sectionRef, { targets: ".main-subtitle", delay: 0.45, scrollTrigger: false });
  useScrollReveal(sectionRef, { targets: "#scroll-down", y: 0, delay: 0.8, scrollTrigger: false });
  useScrollReveal(sectionRef, { targets: ".icon-container", y: 0, x: 20, delay: 0.3, stagger: 0.1, scrollTrigger: false });

  return (
    <section
      ref={sectionRef}
      className="section section-masthead section-fullheight text-left bg-dark-1"
      data-arts-theme-text="light"
    >
      <div className="section-masthead__inner section-fullheight__inner container-fluid">
        <Header
          onContactUs={onContactUs}
          onLegal={onLegal}
          onMobileMenuToggle={onMobileMenuToggle}
          isMobileMenuOpen={isMobileMenuOpen}
        />

        <div className="row section-fullheight__inner">
          <div className="col flex-column main-container right-menu-padding">
            {!showContact && (
              <div className="title-container">
                <div className="section-masthead__subheading small-caps mt-0 mb-1 mb-md-2">
                  <span className="main-subtitle">
                    a rising generation in construction management technology
                  </span>
                </div>
                <div className="w-100" />
                <div className="section-masthead__heading">
                  <h1 className="h1 mt-0 mb-0 main-title">
                    TRANSPARENT PROJECT MANAGEMENT
                  </h1>
                </div>
                <div className="w-100">
                  <div id="scroll-down">
                    <img src={scrollDownIcon} alt="Scroll down" />
                  </div>
                </div>
              </div>
            )}

            {showContact && (
              <>
                <div className="contact-title-container">
                  <div className="contact-title-content">
                    <div className="section-masthead__heading contact-title">
                      <h1 className="h1 mt-0 mb-0 contact-title">Contact Us</h1>
                    </div>
                    <div className="section-masthead__subheading small-caps mt-0 mb-1 mb-md-2">
                      <span className="contact-subtitle">We&apos;d love to hear from you</span>
                    </div>
                  </div>
                </div>
                <div className="contact-form-container right-menu-padding">
                  <ContactForm />
                </div>
              </>
            )}

            <MobileMenu isOpen={isMobileMenuOpen} onContactUs={onContactUs} />
          </div>
        </div>

        <Footer />
      </div>
    </section>
  );
}
